/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../Component/utils/axiosInstance";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/slices/Cart";

const OrderPlacedPage = () => {
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);

  const orderId = queryParams.get("order_id");

  const navigate = useNavigate();

  const getAllAddress = async () => {
    try {
      await axiosInstance
        .get(`/user/order/payment/${orderId}`)
        .then((response) => {
          if (response?.data?.status === true) {
            dispatch(addCart([]));
            navigate("/");
          }
        });
    } catch (error) {}
  };

  useEffect(() => {
    getAllAddress();
  }, []);

  return (
    <div className="container mt-5">
      <div className="alert alert-success" role="alert">
        <h4 className="alert-heading">Congratulations!</h4>
        <p>
          Your order has been successfully placed. We will notify you once it is
          processed.
        </p>
      </div>
      <button
        onClick={() => navigate("/")}
        style={{ width: "fit-content" }}
        className="common_btn  ms-auto mt-2 font-15"
      >
        Return Home
      </button>
    </div>
  );
};

export default OrderPlacedPage;
